import { render } from "./hotelSlider.vue?vue&type=template&id=a52c8350&scoped=true"
import script from "./hotelSlider.vue?vue&type=script&lang=js"
export * from "./hotelSlider.vue?vue&type=script&lang=js"

import "./hotelSlider.vue?vue&type=style&index=0&id=a52c8350&scoped=true&lang=css"

import exportComponent from "/var/www/html/smartbooking/smartbooking-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a52c8350"]])

export default __exports__